import { render } from "./ModalRequestWebinar.vue?vue&type=template&id=ce4a60c0&scoped=true"
import script from "./ModalRequestWebinar.vue?vue&type=script&lang=ts"
export * from "./ModalRequestWebinar.vue?vue&type=script&lang=ts"

import "./ModalRequestWebinar.vue?vue&type=style&index=0&id=ce4a60c0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-ce4a60c0"

export default script